import * as React from 'react';

export const LandingRankedListItemSkeleton = ({
  imageRadius,
}: {
  imageRadius: 'rounded-md' | 'rounded-full';
}) => {
  return (
    <div className="relative flex cursor-pointer items-center gap-3 overflow-hidden rounded-md px-2 py-2">
      {/**
       * Cell Rank + Trending Indicator (conditionally rendered on hover)
       */}
      <div className="flex w-4 flex-00auto flex-col items-center ">
        <div className="h-3 w-2 animate-pulse rounded-full bg-neutral100" />
      </div>

      {/**
       * Cell Image
       */}
      <div
        className={`relative aspect-square h-full w-14 flex-00auto overflow-hidden ${imageRadius} animate-pulse  bg-neutral100`}
      />

      {/**
       * Cell info wrapper (titles, subtitles)
       */}
      <div className="flex flex-col gap-1.5">
        {/**
         * Top row -> playbars and title
         */}
        <div className="h-2 w-12 animate-pulse rounded-full  bg-neutral100" />

        {/**
         * Bottom row -> Subtitle, secondary subtitle, tertiary subtitle
         */}
        <div className="h-2 w-20 animate-pulse rounded-full  bg-neutral100" />
      </div>
    </div>
  );
};
